import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { EmployeesLandingContainer } from './containers';
import EmployeeDetailContainer from './containers/EmployeeDetail/EmployeeDetailContainer';
import { updateBodyClass } from 'src/helpers';
import { BODY_CLASSES } from 'src/constants/constants';
import { EMPLOYEES_URL, EMPLOYEES_TEAM_URL, EMPLOYEE_TEAM_DETAIL_URL, EMPLOYEE_DETAIL_URL } from 'src/constants/constants.js';
import Layout from 'src/ui/layout';
import { connect } from 'react-redux';
import { newDashboardRoutes } from 'src/newDashboardRoutes';

class EmployeesRoot extends Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.EMPLOYEES);
  }
  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.EMPLOYEES);
  }
  render() {
    return (
      <Layout headerName={'Employees'}>
        <Switch>
          <Route path={EMPLOYEE_TEAM_DETAIL_URL} render={props => <EmployeeDetailContainer {...props} team={true} />} />
          <Route path={EMPLOYEES_TEAM_URL} render={props => <EmployeesLandingContainer team={true} {...props} />} />
          <Route path={EMPLOYEES_URL} exact={true} render={props => <EmployeesLandingContainer {...props} />} />
          <Route path={EMPLOYEE_DETAIL_URL} render={props => <EmployeeDetailContainer {...props} />} />
        </Switch>
        {newDashboardRoutes}
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    location: state.router.location.pathname,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesRoot);
